import * as React from 'react';
import { useState } from 'react';
import {
    Typography,
    Button,
    Box,
    TextField,
    withStyles,
    WithStyles as IWithStyles,
    Theme as ITheme,
} from '@material-ui/core';

import { Link } from 'react-router-dom';
import KfLogo from '../../../Assets/kflogo.png';
import { validateEmail } from '../../../Utilities/Validations';
import services from '../../../Api/services';
import CheckIcon from '../../../Assets/check.png';

const styles = (theme: ITheme) => ({
    container: {
        height: '100%',
        width: '100%',
        position: 'relative' as 'relative',
        zIndex: 5000,
    },
    content: {
        display: 'flex',
        flexDirection: 'column' as 'column',
    },
    header: {
        display: 'flex',
        color: theme.palette.common.white,
        background: theme.palette.primary.dark,
        fontWeight: 'normal' as 'normal',
        textTransform: 'uppercase' as 'uppercase',
        padding: `${theme.spacing(1.25)}px ${theme.spacing(2.5)}px`,
    },
    title: {
        fontSize: '2.2em',
        display: 'flex',
        alignItems: 'center',
        minWidth: theme.spacing(30),
    },
    submitButton: {
        float: 'right' as 'right',
        color: theme.palette.common.white,
        marginBottom: '10px',
        marginTop: '10px',
        backgroundColor: theme.palette.primary.main,
        borderRadius: theme.spacing(1),
        width: '28%',
        fontSize: '14px',
        fontWeight: 600,
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
        },
    },
    form: {
        // height: `calc(80vh - ${theme.spacing(8)}px)`,
        maxHeight: `calc(100vh - ${theme.spacing(8)}px)`,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column' as 'column',
        '& > div': {
            width: '100%',
        },
    },
    videoTitle: {
        width: '100%',
        marginBottom: 8,
        '& .MuiOutlinedInput-root': {
            borderWidth: 1,
            borderRadius: 8,
            fontSize: 14,
            '& input': {
                padding: '16px 8px',
            },
            '&.MuiOutlinedInput-multiline': {
                padding: 0,
                '& textarea': {
                    padding: '16px 8px',
                },
            },
            '&:hover fieldset': {
                borderWidth: 1,
                borderColor: '#ffffff',
            },
            '& fieldset': {
                borderWidth: 1,
                transition: 'border-width 0.3s ease',
            },
            '&.Mui-focused fieldset': {
                borderWidth: 1,
                borderColor: '#ffffff',
            },
        },
        '&:last-child': {
            marginBottom: 0,
        },
    },
    buttonRow: {
        borderTop: '1px solid #3F3F50',
        padding: '16px 0 0',
        marginTop: 16,
        textAlign: 'right' as 'right',
        gap: 8,
        display: 'flex',
        justifyContent: 'flex-end',
        width: 'calc(100% + 32px) !important',
        marginLeft: 0,
        paddingRight: '16px',
        '& button': {
            borderRadius: 8,
            padding: '0 16px',
            height: 40,
            fontWeight: 400,
            textTransform: 'capitalize',
            '&.MuiButton-contained:hover': {
                backgroundColor: '#B3211E',
            },
        },
    },
    button: {
        marginLeft: theme.spacing(1),
    },
});

const initialFormState = {
    subject: '',
    message: '',
    email: '',
};

interface ReportProblemProps extends IWithStyles<typeof styles> {
    onClose: () => void;
}

const reportProblem = ({ classes, onClose }: ReportProblemProps) => {
    const [formState, setFormState] = useState(initialFormState);

    const [submissionState, updateSubmissionState] = useState({
        submitted: false,
        inFlight: false,
    });

    const submissionComplete = () => {
        updateSubmissionState({
            ...submissionState,
            submitted: true,
        });
        setFormState(initialFormState);
    };

    const onSubmit = async () => {
        submissionComplete();
        await services.saveFeedback(formState);
    };

    const updateFormState = (fieldName: 'subject' | 'message' | 'email') => (
        event: any
    ) =>
        setFormState({
            ...formState,
            [fieldName]: event.currentTarget.value,
        });

    const isDisabled = () => {
        return (
            formState.subject.length < 1 ||
            formState.email.length < 1 ||
            !validateEmail(formState.email)
        );
    };

    const emailIsInvalid = () => {
        return formState.email.length > 0 && !validateEmail(formState.email);
    };

    return (
        <Box className={classes.container}>
            {/* <Box className={classes.header} style={{ justifyContent: 'flex-end' }}>
                <Box className={classes.title} style={{ marginRight: 'auto', minWidth: '140px' }}>
                <Link to='/video-library/' className={classes.toolbarTitle}>
                <img src={KfLogo} width='120' style={{ marginTop: '16px', marginBottom: '6px' }} />
                </Link>
                </Box>

                <a href='/video-library' style={{ color: '#5B5B63', textDecoration: 'none' }}>
                <Box style={{ height: '40px', width: 'fit-content', display: 'flex', marginTop: '10px', backgroundColor: '#fff', borderRadius: '10px', justifyContent: 'flex-end' }}>
                   <Box display={{ xs: 'none', sm: 'block' }} style={{ float: 'right', textAlign: 'center', margin: '10px' }}>Back</Box>
                   <Box display={{ xs: 'block', sm: 'none' }} style={{ float: 'right', textAlign: 'center', margin: '10px' }}>Back</Box>
                </Box>
                </a>
            </Box> */}
            <Box className={classes.form}>
                {submissionState.submitted ? (
                    <Box style={{ width: 'fit-content', margin: 'auto auto' }}>
                        <Typography variant='h4'>
                            Thank you for your feedback!
                        </Typography>
                    </Box>
                ) : (
                    <>
                        <Box>
                            <label
                                style={{
                                    display: 'block',
                                    marginBottom: 8,
                                    fontWeight: 500,
                                }}
                            >
                                Subject
                                <span style={{ color: '#DB2C29' }}>
                                    {' \u002A'}
                                </span>
                            </label>
                            <TextField
                                variant='outlined'
                                required
                                fullWidth
                                value={formState.subject}
                                onChange={updateFormState('subject')}
                                id='standard-required'
                                // label='Subject'
                                placeholder='www.example.com'
                                className={classes.videoTitle}
                            />
                            <label
                                style={{
                                    display: 'block',
                                    marginBottom: 8,
                                    fontWeight: 500,
                                }}
                            >
                                Email
                                <span style={{ color: '#DB2C29' }}>
                                    {' \u002A'}
                                </span>
                            </label>
                            <TextField
                                required
                                variant='outlined'
                                fullWidth
                                value={formState.email}
                                onChange={updateFormState('email')}
                                id='standard-required'
                                // label='Email'
                                placeholder='me@email.com'
                                error={emailIsInvalid()}
                                helperText={
                                    emailIsInvalid() ? 'Email is not valid' : ''
                                }
                                className={classes.videoTitle}
                            />
                            <label
                                style={{
                                    display: 'block',
                                    marginBottom: 8,
                                    fontWeight: 500,
                                }}
                            >
                                Notes
                            </label>
                            <TextField
                                id='outlined-multiline-static'
                                // label='Description'
                                placeholder='Add your query here'
                                onChange={updateFormState('message')}
                                value={formState.message}
                                fullWidth
                                multiline
                                rows='4'
                                variant='outlined'
                                className={classes.videoTitle}
                            />
                        </Box>
                        <Box className={classes.buttonRow}>
                            <Button
                                variant='outlined'
                                className={classes.button}
                                onClick={onClose}
                            >
                                Cancel
                            </Button>
                            <Button
                                aria-label='Submit'
                                variant='contained'
                                color='primary'
                                onClick={onSubmit}
                                // className={classes.submitButton}
                                disabled={isDisabled()}
                                // startIcon={
                                //     <img
                                //         src={CheckIcon}
                                //         style={{
                                //             opacity: isDisabled() ? 0.35 : 1,
                                //         }}
                                //         alt='got it'
                                //         width='24'
                                //         height='24'
                                //     />
                                // }
                            >
                                Submit
                            </Button>
                        </Box>
                    </>
                )}
            </Box>
        </Box>
    );
};

export const ReportProblem = withStyles(styles)(reportProblem);
